import { apiClientWithoutHandler } from 'src/js/api';
import { APIPath } from 'src/js/api/route-path-index';
import { createWatchStore, updateWatchStore, updateWatchStoreProp } from 'src/js/store/use-watch';

import { GetAllVideoInputsResponse, VideoInputViewModel, mapVideoInputsResponse } from './video-input-models';

const videoInputs: VideoInputViewModel[] = [];
createWatchStore(videoInputs);

export interface VideoInputStore {
  data: VideoInputViewModel[];
  updated: Date;
}

export const videoInputStore: VideoInputStore = {
  data: videoInputs,
  updated: new Date(),
};
createWatchStore(videoInputStore);

export default videoInputs;

export const saveResponseToVideoInputs = (response: VideoInputViewModel[]) => {
  updateWatchStore(videoInputs, response);
  updateWatchStoreProp(videoInputStore, {
    updated: new Date(),
  });
};

export const fetchVideoInputs = () =>
  apiClientWithoutHandler.genericController.get<GetAllVideoInputsResponse>(APIPath.vidin).then((res) => {
    if (res.ok) {
      const response = res.data;
      if (response) {
        const viewModels = mapVideoInputsResponse(response);
        saveResponseToVideoInputs(viewModels);
      }
    }
    return res;
  });
